import {
  REQUEST_INVENTORY_CONVERTS,
  FETCH_INVENTORY_CONVERTS_SUCCESS,
  FETCH_INVENTORY_CONVERTS_FAILURE,
  SELECT_INVENTORY_CONVERT,
  RESET_CURRENT_INVENTORY_CONVERT,
  REQUEST_INVENTORY_CONVERT_DETAIL,
  FETCH_INVENTORY_CONVERT_DETAIL_SUCCESS,
  FETCH_INVENTORY_CONVERT_DETAIL_FAILURE,
  REQUEST_INVENTORIES_BIN,
  FETCH_INVENTORIES_BIN_SUCCESS,
  FETCH_INVENTORIES_BIN_FAILURE,
  REQUEST_CREATING_INVENTORY_CONVERT,
  CREATE_INVENTORY_CONVERT_SUCCESS,
  CREATE_INVENTORY_CONVERT_FAILURE,
  REQUEST_EDITING_INVENTORY_CONVERT,
  EDIT_INVENTORY_CONVERT_SUCCESS,
  EDIT_INVENTORY_CONVERT_FAILURE,
  REQUEST_NEW_CONVERT,
  NEW_CONVERT_SUCCESS,
  NEW_CONVERT_FAILURE,
} from '../actions/type';

const INITIAL_STATE = {
  all: [],
  currentInventoryConvert: null,
  currentInventoryConvertDetail: null,
  isLoading: false,
  error: null,
  detailIsLoading: false,
  detailError: null,
  isCreating: false,
  createError: null,
  created: false,
  isEditing: false,
  editError: null,
  edited: false,

  inventories: null,
  inventoriesIsLoading: false,
  inventoriesError: null,
  inventoryConvertIsCreating: false,
  inventoryConvertCreateError: null,
  inventoryConvertCreated: false,
  inventoryConvertIsEditing: false,
  inventoryConvertEditError: null,
  inventoryConvertEdited: false,
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        // Inventory Relocation action handlers
        case REQUEST_INVENTORY_CONVERTS:
            return { ...state, error: null, isLoading: true };
        case FETCH_INVENTORY_CONVERTS_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_INVENTORY_CONVERTS_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_INVENTORY_CONVERT:
            return { ...state, currentInventoryConvert: action.payload };
        case RESET_CURRENT_INVENTORY_CONVERT:
            return { ...state, currentInventoryConvert: null, currentInventoryConvertDetail: null, inventories: null };
        case REQUEST_INVENTORY_CONVERT_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_INVENTORY_CONVERT_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentInventoryConvertDetail: action.payload, currentInventoryConvert: null, detailError: null, detailIsLoading: false };
        case FETCH_INVENTORY_CONVERT_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_INVENTORIES_BIN:
            return { ...state, inventoriesError: null, inventoriesIsLoading: true };
        case FETCH_INVENTORIES_BIN_SUCCESS:
            return { ...state, inventories: action.payload.data, inventoriesError: null, inventoriesIsLoading: false };
        case FETCH_INVENTORIES_BIN_FAILURE:
            const inventoriesError = action.payload || { message: action.payload.message };
            return { ...state, inventories: [], inventoriesError: inventoriesError, inventoriesIsLoading: false };
        // case REQUEST_CREATING_INVENTORY_CONVERT:
        //     return { ...state, inventoryConvertIsCreating: true, inventoryConvertCreateError: null, inventoryConvertCreated: false };
        // case CREATE_INVENTORY_CONVERT_SUCCESS:
        //     return { ...state, inventoryConvertIsCreating: false, inventoryConvertCreateError: null, inventoryConvertCreated: true };
        // case CREATE_INVENTORY_CONVERT_FAILURE:
        //     const inventoryConvertCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
        //     return { ...state, inventoryConvertIsCreating: false, inventoryConvertCreateError: inventoryConvertCreateError, inventoryConvertCreated: false };
        case REQUEST_EDITING_INVENTORY_CONVERT:
            return { ...state, inventoryConvertIsEditing: true, inventoryConvertEditError: null, inventoryConvertEdited: false };
        case EDIT_INVENTORY_CONVERT_SUCCESS:
            return { ...state, inventoryConvertIsEditing: false, inventoryConvertEditError: null, inventoryConvertEdited: true };
        case EDIT_INVENTORY_CONVERT_FAILURE:
            const inventoryConvertEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, inventoryConvertIsEditing: false, inventoryConvertEditError: inventoryConvertEditError, inventoryConvertEdited: false };
        case REQUEST_NEW_CONVERT:
            return { ...state, inventoryConvertIsCreating: true, inventoryConvertCreated: false };
        case NEW_CONVERT_SUCCESS:
            return { ...state, inventoryConvertIsCreating: false, inventoryConvertCreated: true };
        case NEW_CONVERT_FAILURE:
            const inventoryConvertCreateError = action.payload.data || { message: action.payload.message };
            alert(JSON.stringify(inventoryConvertCreateError));
            return { ...state, inventoryConvertIsCreating: false, inventoryConvertCreated: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/inventoryConverts_reducer.js